import { cn } from '../../lib/cn';

const STATUS_COLORS = {
  unanswered: 'bg-red-100 dark:bg-red-900/30 border-red-200 dark:border-red-800',
  in_progress: 'bg-yellow-100 dark:bg-yellow-900/30 border-yellow-200 dark:border-yellow-800',
  answered: 'bg-green-100 dark:bg-green-900/30 border-green-200 dark:border-green-800',
  answered_incorrect: 'bg-red-50 dark:bg-red-900/20 border-red-300 dark:border-red-700',
  not_submitted: 'bg-gray-50 dark:bg-gray-800/40 border-gray-200 dark:border-gray-700',
};

const STATUS_TEXT_COLORS = {
  unanswered: 'text-red-600 dark:text-red-400',
  in_progress: 'text-yellow-600 dark:text-yellow-400',
  answered: 'text-green-600 dark:text-green-400',
  answered_incorrect: 'text-red-600 dark:text-red-400',
  not_submitted: 'text-gray-400 dark:text-gray-500',
};

export default function SessionMapCell({ cellData, isCurrent, isSelected, needsReview, correct, onClick }) {
  const status = cellData?.status || 'unanswered';
  const displayValue = cellData?.display_value;
  const progress = cellData?.progress || 0;

  // Use answered_incorrect variant when explicitly marked incorrect
  const effectiveStatus = status === 'answered' && correct === false ? 'answered_incorrect' : status;

  return (
    <div
      className={cn(
        'relative flex items-center justify-center rounded-lg border-2 min-h-[40px] min-w-[60px] transition-all duration-200',
        STATUS_COLORS[effectiveStatus],
        isSelected && 'ring-2 ring-blue-600 ring-offset-2 dark:ring-blue-400 dark:ring-offset-gray-900 scale-110',
        isCurrent && !isSelected && 'ring-2 ring-blue-500 ring-offset-2 dark:ring-offset-gray-900',
        needsReview && !isCurrent && !isSelected && 'ring-2 ring-amber-400 ring-offset-1 dark:ring-offset-gray-900',
        onClick && 'cursor-pointer hover:opacity-80'
      )}
      onClick={onClick}
    >
      {/* Progress bar for in-progress items */}
      {status === 'in_progress' && progress > 0 && progress < 100 && (
        <div
          className="absolute bottom-0 left-0 h-1 bg-yellow-400 dark:bg-yellow-500 rounded-b"
          style={{ width: `${progress}%` }}
        />
      )}

      {/* Display value */}
      {displayValue ? (
        <span className={cn('text-sm font-medium', STATUS_TEXT_COLORS[effectiveStatus])}>
          {displayValue}
        </span>
      ) : (
        <span className={cn('text-xs', STATUS_TEXT_COLORS[effectiveStatus])}>
          {status === 'in_progress' ? '...' : '-'}
        </span>
      )}

      {/* Current question indicator */}
      {isCurrent && (
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full animate-pulse" />
      )}

      {/* Needs review indicator */}
      {needsReview && !isCurrent && (
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-amber-400 rounded-full" />
      )}
    </div>
  );
}
